var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sys-register-base", {
    attrs: {
      loading: _vm.loading,
      model: _vm.model,
      title: _vm.title,
      icon: "mdi-grid",
      show: _vm.dialog,
      maxWidth: "90%",
    },
    on: {
      onSave: _vm.save,
      "update:model": function ($event) {
        _vm.model = $event
      },
      "update:show": function ($event) {
        _vm.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "tools",
        fn: function () {
          return [
            _vm.tab == 1 && _vm.model.id
              ? _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      attrs: {
                                        disabled: _vm.disableSaveDisciplines,
                                        loading: _vm.loadingSaveDisciplines,
                                        color: "success darken-1",
                                        icon: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          $event.stopPropagation()
                                          return _vm.updateDisciplines()
                                        },
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _c("v-icon", [
                                    _vm._v("mdi-content-save-edit-outline"),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4121831979
                    ),
                  },
                  [_c("span", [_vm._v(" Salvar alterações ")])]
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "form",
        fn: function () {
          return [
            _c(
              "v-tabs",
              {
                staticClass: "ma-0",
                model: {
                  value: _vm.tab,
                  callback: function ($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab",
                },
              },
              [
                _c("v-tab", { key: "main" }, [_vm._v("Dados")]),
                _c("v-tab", { key: "disciplines" }, [_vm._v("Disciplinas")]),
              ],
              1
            ),
            _c(
              "v-tabs-items",
              {
                model: {
                  value: _vm.tab,
                  callback: function ($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab",
                },
              },
              [
                _c(
                  "v-tab-item",
                  { key: "main" },
                  [
                    _c(
                      "v-container",
                      [
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "8" } },
                              [
                                _c("sys-select-course", {
                                  attrs: {
                                    model: _vm.model.course_id,
                                    error:
                                      _vm.errors.course_id &&
                                      _vm.errors.length > 0,
                                    errors: _vm.errors.course_id,
                                    label: "Curso*",
                                    autoComplete: "",
                                  },
                                  on: {
                                    "update:model": function ($event) {
                                      return _vm.$set(
                                        _vm.model,
                                        "course_id",
                                        $event
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "4" } },
                              [
                                _c("sys-select-curriculum-category", {
                                  attrs: {
                                    model: _vm.model.curriculum_category_id,
                                    error: _vm.errors.length > 0,
                                    errors: _vm.errors.curriculum_category_id,
                                    label: "Categoria*",
                                  },
                                  on: {
                                    "update:model": function ($event) {
                                      return _vm.$set(
                                        _vm.model,
                                        "curriculum_category_id",
                                        $event
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "7" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    dense: "",
                                    autofocus: "",
                                    error: !!_vm.errors.name,
                                    "error-messages": _vm.errors.name,
                                    label: "Nome/Sigla*",
                                  },
                                  model: {
                                    value: _vm.model.name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "name", $$v)
                                    },
                                    expression: "model.name",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "3" } },
                              [
                                _c("sys-select-frequency", {
                                  attrs: {
                                    model: _vm.model.frequency_id,
                                    error: _vm.errors.length > 0,
                                    errors: _vm.errors.frequency_id,
                                    label: "Periodicidade*",
                                    dense: "",
                                  },
                                  on: {
                                    "update:model": function ($event) {
                                      return _vm.$set(
                                        _vm.model,
                                        "frequency_id",
                                        $event
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "2" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    dense: "",
                                    error: !!_vm.errors.number_modules,
                                    "error-messages": _vm.errors.number_modules,
                                    label: "Períodos*",
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "append",
                                      fn: function () {
                                        return [
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: { bottom: "" },
                                              scopedSlots: _vm._u([
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "v-btn",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              attrs: {
                                                                disabled:
                                                                  _vm.model
                                                                    .number_modules <
                                                                    1 ||
                                                                  _vm.model
                                                                    .number_modules >
                                                                    24,
                                                                small: "",
                                                                icon: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.preventDefault()
                                                                    $event.stopPropagation()
                                                                    return _vm.loadSequencies()
                                                                  },
                                                              },
                                                            },
                                                            "v-btn",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                btn: "",
                                                                color:
                                                                  "green darken-1",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-flash"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ]),
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(" Carregar Períodos "),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ]),
                                  model: {
                                    value: _vm.model.number_modules,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "number_modules", $$v)
                                    },
                                    expression: "model.number_modules",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "6" } },
                              [
                                _c("sys-select-campus", {
                                  attrs: {
                                    model: _vm.model.campuses,
                                    error: _vm.errors.length > 0,
                                    errors: _vm.errors.campuses,
                                    label: "Campus",
                                    multiple: "",
                                    dense: "",
                                  },
                                  on: {
                                    "update:model": function ($event) {
                                      return _vm.$set(
                                        _vm.model,
                                        "campuses",
                                        $event
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "3" } },
                              [
                                _c("sys-select-curriculum-status", {
                                  attrs: {
                                    model: _vm.model.curriculum_status_id,
                                    error: _vm.errors.length > 0,
                                    errors: _vm.errors.curriculum_status_id,
                                    label: "Status*",
                                    dense: "",
                                  },
                                  on: {
                                    "update:model": function ($event) {
                                      return _vm.$set(
                                        _vm.model,
                                        "curriculum_status_id",
                                        $event
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "3" } },
                              [
                                _c("sys-select-curriculum-regime", {
                                  attrs: {
                                    model: _vm.model.curriculum_regime_id,
                                    error: _vm.errors.length > 0,
                                    errors: _vm.errors.curriculum_regime_id,
                                    label: "Regime*",
                                    dense: "",
                                  },
                                  on: {
                                    "update:model": function ($event) {
                                      return _vm.$set(
                                        _vm.model,
                                        "curriculum_regime_id",
                                        $event
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "3" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    dense: "",
                                    error: !!_vm.errors.year,
                                    "error-messages": _vm.errors.year,
                                    label: "Ano Ingresso",
                                  },
                                  model: {
                                    value: _vm.model.year,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "year", $$v)
                                    },
                                    expression: "model.year",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "3" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    dense: "",
                                    error: !!_vm.errors.period,
                                    "error-messages": _vm.errors.period,
                                    label: "Semestre Ingresso",
                                  },
                                  model: {
                                    value: _vm.model.period,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "period", $$v)
                                    },
                                    expression: "model.period",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "3" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    dense: "",
                                    error: !!_vm.errors.workload,
                                    "error-messages": _vm.errors.workload,
                                    label: "Carga Horária",
                                  },
                                  model: {
                                    value: _vm.model.workload,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "workload", $$v)
                                    },
                                    expression: "model.workload",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "3" } },
                              [
                                _c("s-text-field", {
                                  attrs: {
                                    dense: "",
                                    code: "",
                                    "error-messages": _vm.errors.code,
                                    label: "Código",
                                  },
                                  model: {
                                    value: _vm.model.code,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "code", $$v)
                                    },
                                    expression: "model.code",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "12" } },
                              [
                                _c("v-textarea", {
                                  attrs: {
                                    error: !!_vm.errors.description,
                                    "error-messages": _vm.errors.description,
                                    label: "Descrição",
                                    counter: 255,
                                    rules: [
                                      (v) =>
                                        !v ||
                                        v.length <= 255 ||
                                        "Máximo de 255 caracteres atingido",
                                    ],
                                    outlined: "",
                                  },
                                  model: {
                                    value: _vm.model.description,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "description", $$v)
                                    },
                                    expression: "model.description",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-tab-item",
                  { key: "disciplines" },
                  [
                    _c(
                      "v-row",
                      {
                        staticClass: "matrix-split",
                        attrs: { "no-gutters": "" },
                      },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "matrix-sidebar",
                            attrs: { cols: "12", sm: "4", md: "3" },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "matrix-sidebar__header pa-3" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "d-flex align-center mb-2" },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { left: "", small: "" } },
                                      [_vm._v("mdi-format-list-numbered")]
                                    ),
                                    _c("strong", [_vm._v("Períodos")]),
                                    _c("v-spacer"),
                                    _vm.model.number_modules
                                      ? _c(
                                          "v-tooltip",
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "v-btn",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              attrs: {
                                                                icon: "",
                                                                "x-small": "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.preventDefault()
                                                                    $event.stopPropagation()
                                                                    return _vm.loadSequencies()
                                                                  },
                                                              },
                                                            },
                                                            "v-btn",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                small: "",
                                                                color:
                                                                  "primary",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-refresh"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              4057846763
                                            ),
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                "Recarregar a partir do nº de períodos da matriz"
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _c("v-text-field", {
                                  attrs: {
                                    placeholder: "Buscar período / disciplina…",
                                    "prepend-inner-icon": "mdi-magnify",
                                    clearable: "",
                                    dense: "",
                                    outlined: "",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.sequencySearch,
                                    callback: function ($$v) {
                                      _vm.sequencySearch = $$v
                                    },
                                    expression: "sequencySearch",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "matrix-sidebar__list" },
                              [
                                _c(
                                  "v-list",
                                  { attrs: { dense: "", nav: "" } },
                                  [
                                    _vm._l(
                                      _vm.filteredSequencies,
                                      function (sequency) {
                                        return _c(
                                          "v-list-item",
                                          {
                                            key: sequency.curriculum_sequency_id,
                                            staticClass: "matrix-period-item",
                                            class: {
                                              "matrix-period-item--active":
                                                _vm.selectedSequencyId ===
                                                sequency.curriculum_sequency_id,
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.selectedSequencyId =
                                                  sequency.curriculum_sequency_id
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-list-item-avatar",
                                              { staticClass: "period-avatar" },
                                              [
                                                sequency.sequency.id != 99
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          sequency.sequency.id
                                                        ) + "º"
                                                      ),
                                                    ])
                                                  : _c(
                                                      "v-icon",
                                                      { attrs: { small: "" } },
                                                      [_vm._v("mdi-puzzle")]
                                                    ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-list-item-content",
                                              [
                                                _c("v-list-item-title", [
                                                  sequency.sequency.id == 99
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            sequency.sequency
                                                              .name
                                                          )
                                                        ),
                                                      ])
                                                    : sequency.initials
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            sequency.initials
                                                          )
                                                        ),
                                                      ])
                                                    : _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "grey--text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Período " +
                                                              _vm._s(
                                                                sequency
                                                                  .sequency.id
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                ]),
                                                sequency.description
                                                  ? _c("v-list-item-subtitle", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            sequency.description
                                                          ) +
                                                          " "
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-list-item-action",
                                              [
                                                _c(
                                                  "v-chip",
                                                  {
                                                    attrs: {
                                                      "x-small": "",
                                                      label: "",
                                                      outlined:
                                                        !sequency
                                                          .sequencyDisciplines
                                                          .length,
                                                      color: sequency
                                                        .sequencyDisciplines
                                                        .length
                                                        ? "primary"
                                                        : "",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          sequency
                                                            .sequencyDisciplines
                                                            .length
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    !_vm.filteredSequencies.length
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-caption grey--text text-center pa-4",
                                          },
                                          [
                                            _vm._v(
                                              " Nenhum período encontrado. "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "matrix-editor pa-0",
                            attrs: { cols: "12", sm: "8", md: "9" },
                          },
                          [
                            !_vm.currentSequency
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "text-center grey--text py-12",
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          large: "",
                                          color: "grey lighten-1",
                                        },
                                      },
                                      [_vm._v("mdi-arrow-left-circle-outline")]
                                    ),
                                    _c("div", { staticClass: "mt-2" }, [
                                      _vm._v(
                                        "Selecione um período à esquerda para editar suas disciplinas."
                                      ),
                                    ]),
                                  ],
                                  1
                                )
                              : [
                                  _c(
                                    "div",
                                    { staticClass: "matrix-editor__head pa-3" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-center mb-3",
                                        },
                                        [
                                          _c(
                                            "v-avatar",
                                            {
                                              staticClass:
                                                "white--text mr-3 font-weight-bold",
                                              attrs: {
                                                size: "40",
                                                color: "primary",
                                              },
                                            },
                                            [
                                              _vm.currentSequency.sequency.id !=
                                              99
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.currentSequency
                                                          .sequency.id
                                                      ) + "º"
                                                    ),
                                                  ])
                                                : _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        small: "",
                                                        color: "white",
                                                      },
                                                    },
                                                    [_vm._v("mdi-puzzle")]
                                                  ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "flex-grow-1" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-subtitle-1 font-weight-bold",
                                                },
                                                [
                                                  _vm.currentSequency.sequency
                                                    .id == 99
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.currentSequency
                                                              .sequency.name
                                                          )
                                                        ),
                                                      ])
                                                    : _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.currentSequency
                                                              .sequency.id
                                                          ) + "º Período"
                                                        ),
                                                      ]),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-caption grey--text",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.currentSequency
                                                          .sequencyDisciplines
                                                          .length
                                                      ) +
                                                      " disciplina(s) "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                small: "",
                                                color: "primary",
                                                depressed: "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  $event.stopPropagation()
                                                  return _vm.addItem(
                                                    _vm.currentSequency,
                                                    false
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    left: "",
                                                    small: "",
                                                  },
                                                },
                                                [_vm._v("mdi-plus")]
                                              ),
                                              _vm._v(" Adicionar disciplina "),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.currentSequency.sequency.id != 99
                                        ? _c(
                                            "v-row",
                                            {
                                              staticClass: "mb-1",
                                              attrs: { dense: "" },
                                            },
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: {
                                                    cols: "12",
                                                    md: "4",
                                                  },
                                                },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      label:
                                                        "Módulo (sigla curta)",
                                                      outlined: "",
                                                      dense: "",
                                                      "hide-details": "",
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        _vm.disableSaveDisciplines = false
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.currentSequency
                                                          .initials,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.currentSequency,
                                                          "initials",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "currentSequency.initials",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: {
                                                    cols: "12",
                                                    md: "8",
                                                  },
                                                },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      label:
                                                        "Descrição do período",
                                                      outlined: "",
                                                      dense: "",
                                                      "hide-details": "",
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        _vm.disableSaveDisciplines = false
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.currentSequency
                                                          .description,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.currentSequency,
                                                          "description",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "currentSequency.description",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("v-autocomplete", {
                                                    attrs: {
                                                      value:
                                                        _vm.currentSequency
                                                          .required_sequencies ||
                                                        [],
                                                      items:
                                                        _vm.getOtherSequencies(
                                                          _vm.currentSequency
                                                        ),
                                                      "item-text": _vm.seqLabel,
                                                      "item-value": "id",
                                                      multiple: "",
                                                      chips: "",
                                                      "small-chips": "",
                                                      "deletable-chips": "",
                                                      dense: "",
                                                      outlined: "",
                                                      "hide-details": "",
                                                      label:
                                                        "Pré-requisitos de ciclo",
                                                      placeholder:
                                                        "Períodos que precisam estar 100% cursados antes deste",
                                                      "prepend-inner-icon":
                                                        "mdi-link-variant",
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        return _vm.setRequiredSequencies(
                                                          _vm.currentSequency,
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "matrix-editor__body px-3 pb-3",
                                    },
                                    [
                                      _c("v-data-table", {
                                        staticClass:
                                          "elevation-0 matrix-disciplines",
                                        attrs: {
                                          headers: _vm.headers,
                                          items:
                                            _vm.currentSequency
                                              .sequencyDisciplines,
                                          "sort-by": "discipline.name",
                                          "hide-default-footer": "",
                                          "items-per-page": 200,
                                          "no-data-text":
                                            "Nenhuma disciplina vinculada — clique em 'Adicionar disciplina'",
                                          dense: "",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "item.discipline",
                                            fn: function ({ item }) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "font-weight-medium",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.discipline
                                                          .name_complete
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                item.discipline.code
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "grey--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "[" +
                                                            _vm._s(
                                                              item.discipline
                                                                .code
                                                            ) +
                                                            "]"
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                          {
                                            key: "item.grid_category_id",
                                            fn: function ({ item }) {
                                              return [
                                                _c("sys-select-grid-category", {
                                                  attrs: {
                                                    model:
                                                      item.grid_category_id,
                                                    error:
                                                      _vm.errors.length > 0,
                                                    errors:
                                                      _vm.errors
                                                        .grid_category_id,
                                                    itemText: "initials",
                                                    clearable: "",
                                                    label: "",
                                                  },
                                                  on: {
                                                    "update:model": function (
                                                      $event
                                                    ) {
                                                      return _vm.$set(
                                                        item,
                                                        "grid_category_id",
                                                        $event
                                                      )
                                                    },
                                                    input: function ($event) {
                                                      _vm.disableSaveDisciplines = false
                                                    },
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                          {
                                            key: "item.prerequisites",
                                            fn: function ({ item }) {
                                              return [
                                                _c(
                                                  "div",
                                                  [
                                                    (
                                                      item.prerequisites_global ||
                                                      []
                                                    ).length
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "d-flex flex-wrap mb-1",
                                                            staticStyle: {
                                                              gap: "4px",
                                                            },
                                                          },
                                                          _vm._l(
                                                            item.prerequisites_global ||
                                                              [],
                                                            function (gId) {
                                                              return _c(
                                                                "v-tooltip",
                                                                {
                                                                  key:
                                                                    "g-" + gId,
                                                                  attrs: {
                                                                    bottom: "",
                                                                  },
                                                                  scopedSlots:
                                                                    _vm._u(
                                                                      [
                                                                        {
                                                                          key: "activator",
                                                                          fn: function ({
                                                                            on,
                                                                            attrs,
                                                                          }) {
                                                                            return [
                                                                              _c(
                                                                                "v-chip",
                                                                                _vm._g(
                                                                                  _vm._b(
                                                                                    {
                                                                                      class:
                                                                                        {
                                                                                          "global-prereq-off":
                                                                                            _vm.isGlobalDisabled(
                                                                                              item,
                                                                                              gId
                                                                                            ),
                                                                                        },
                                                                                      attrs:
                                                                                        {
                                                                                          "x-small":
                                                                                            "",
                                                                                          label:
                                                                                            "",
                                                                                          color:
                                                                                            _vm.isGlobalDisabled(
                                                                                              item,
                                                                                              gId
                                                                                            )
                                                                                              ? "grey lighten-3"
                                                                                              : "indigo lighten-4",
                                                                                          close:
                                                                                            !_vm.isGlobalDisabled(
                                                                                              item,
                                                                                              gId
                                                                                            ),
                                                                                          "close-icon":
                                                                                            "mdi-close-circle",
                                                                                        },
                                                                                      on: {
                                                                                        "click:close":
                                                                                          function (
                                                                                            $event
                                                                                          ) {
                                                                                            return _vm.toggleGlobalDisabled(
                                                                                              item,
                                                                                              gId
                                                                                            )
                                                                                          },
                                                                                      },
                                                                                    },
                                                                                    "v-chip",
                                                                                    attrs,
                                                                                    false
                                                                                  ),
                                                                                  on
                                                                                ),
                                                                                [
                                                                                  _c(
                                                                                    "v-icon",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          "x-small":
                                                                                            "",
                                                                                          left: "",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "mdi-link-variant"
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " " +
                                                                                      _vm._s(
                                                                                        _vm.getDisciplineLabel(
                                                                                          gId
                                                                                        )
                                                                                      ) +
                                                                                      " "
                                                                                  ),
                                                                                  _vm.isGlobalDisabled(
                                                                                    item,
                                                                                    gId
                                                                                  )
                                                                                    ? _c(
                                                                                        "v-icon",
                                                                                        {
                                                                                          attrs:
                                                                                            {
                                                                                              "x-small":
                                                                                                "",
                                                                                              right:
                                                                                                "",
                                                                                            },
                                                                                          on: {
                                                                                            click:
                                                                                              function (
                                                                                                $event
                                                                                              ) {
                                                                                                $event.stopPropagation()
                                                                                                return _vm.toggleGlobalDisabled(
                                                                                                  item,
                                                                                                  gId
                                                                                                )
                                                                                              },
                                                                                          },
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            " mdi-restore "
                                                                                          ),
                                                                                        ]
                                                                                      )
                                                                                    : _vm._e(),
                                                                                ],
                                                                                1
                                                                              ),
                                                                            ]
                                                                          },
                                                                        },
                                                                      ],
                                                                      null,
                                                                      true
                                                                    ),
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      " Herdado da disciplina · " +
                                                                        _vm._s(
                                                                          _vm.isGlobalDisabled(
                                                                            item,
                                                                            gId
                                                                          )
                                                                            ? "desativado nesta matriz (clique no ícone para reativar)"
                                                                            : "clique no X para desativar nesta matriz"
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    _c("v-autocomplete", {
                                                      attrs: {
                                                        value:
                                                          item.prerequisites ||
                                                          [],
                                                        items:
                                                          _vm.getPrerequisiteOptions(
                                                            item
                                                          ),
                                                        "item-text":
                                                          "discipline.name_complete",
                                                        "item-value":
                                                          "discipline_id",
                                                        multiple: "",
                                                        chips: "",
                                                        "small-chips": "",
                                                        "deletable-chips": "",
                                                        dense: "",
                                                        "hide-details": "",
                                                        placeholder:
                                                          "Adicionar pré-requisito desta matriz",
                                                        "menu-props": {
                                                          maxHeight: 300,
                                                        },
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          return _vm.setPrerequisites(
                                                            item,
                                                            $event
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                          {
                                            key: "item.actions",
                                            fn: function ({ item }) {
                                              return [
                                                _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: { bottom: "" },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function ({
                                                            on,
                                                            attrs,
                                                          }) {
                                                            return [
                                                              _c(
                                                                "v-btn",
                                                                _vm._g(
                                                                  _vm._b(
                                                                    {
                                                                      attrs: {
                                                                        icon: "",
                                                                        "x-small":
                                                                          "",
                                                                        color:
                                                                          "error",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.showDeleteItem(
                                                                              _vm.currentSequency,
                                                                              item
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    "v-btn",
                                                                    attrs,
                                                                    false
                                                                  ),
                                                                  on
                                                                ),
                                                                [
                                                                  _c(
                                                                    "v-icon",
                                                                    {
                                                                      attrs: {
                                                                        small:
                                                                          "",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "mdi-delete"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        "Remover disciplina deste período"
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("emc-alert-snackbar", {
              attrs: {
                show: !!_vm.message.length,
                message: _vm.message,
                color: _vm.error ? "error" : "success",
              },
            }),
            _c("sys-find-discipline", {
              attrs: {
                showAdd: "",
                showSelect: "",
                singleSelect: false,
                show: _vm.dialogAddDiscipline,
              },
              on: {
                onSelect: function ($event) {
                  return _vm.selectDiscipline($event)
                },
                "update:show": function ($event) {
                  _vm.dialogAddDiscipline = $event
                },
              },
            }),
            _c("emc-alert-modal", {
              attrs: {
                text: "Deseja excluir a disciplina?",
                show: _vm.showDelete,
              },
              on: {
                "update:show": function ($event) {
                  _vm.showDelete = $event
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "actions",
                  fn: function () {
                    return [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "error" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.deleteItem()
                            },
                          },
                        },
                        [
                          _vm._v("Excluir "),
                          _c("v-icon", { attrs: { right: "", dark: "" } }, [
                            _vm._v("mdi-delete"),
                          ]),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }